// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"318": "__federation_expose_InsuranceStats","560": "__federation_expose_Ledger","841": "__federation_expose_PatientStats","889": "__federation_expose_AiUsageStats",}[chunkId] + "." + {"318": "6d6e254d","560": "90955db3","841": "e7ba8ea6","889": "418d0206",}[chunkId] + ".css"
}